__turbopack_context__.v({
  "blue": "PriceDisplay-module-scss-module__SYV7-G__blue",
  "center": "PriceDisplay-module-scss-module__SYV7-G__center",
  "green": "PriceDisplay-module-scss-module__SYV7-G__green",
  "loader": "PriceDisplay-module-scss-module__SYV7-G__loader",
  "price": "PriceDisplay-module-scss-module__SYV7-G__price",
  "promo-loader": "PriceDisplay-module-scss-module__SYV7-G__promo-loader",
  "without-promo": "PriceDisplay-module-scss-module__SYV7-G__without-promo",
});
